module.exports = __webpack_public_path__ + "img/btn.885d1479.png";